/*eslint @typescript-eslint/ban-types: "off" */
import PermissionSchemesListItem from './PermissionSchemesListItem';
import { PermissionSchemesListContainer } from './styles';
import { IProviders } from 'store/store';
import {
  ICompany,
  ICompanyPermissionScheme,
} from 'store/companies/companiesTypes';

interface IPermissionSchemesListProps {
  allTags: IProviders['tags'];
  companyProvidersIdName: [number, string][];
  permissionSchemes: { [key: number]: ICompanyPermissionScheme };
  deletePermissionScheme: (
    permissionSchemeId: number,
    companyId: number
  ) => () => void;
  updatePermissionScheme: (
    permissionScheme: ICompanyPermissionScheme
  ) => Promise<any>;
  company: ICompany;
}

const PermissionSchemesList: React.FC<IPermissionSchemesListProps> = ({
  permissionSchemes,
  deletePermissionScheme,
  updatePermissionScheme,
  allTags,
  companyProvidersIdName,
  company,
}) => {
  const list = Object.values(permissionSchemes).map(
    (permissionScheme, index) => {
      return (
        <PermissionSchemesListItem
          allTags={allTags}
          companyProvidersIdName={companyProvidersIdName}
          key={index}
          permissionSchemeItem={permissionScheme}
          allPermissionSchemes={Object.values(permissionSchemes)}
          deletePermissionScheme={deletePermissionScheme}
          updatePermissionScheme={updatePermissionScheme}
          company={company}
        />
      );
    }
  );

  return (
    <PermissionSchemesListContainer>{list}</PermissionSchemesListContainer>
  );
};

export default PermissionSchemesList;
